import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import LessonsLayer from "../components/LessonsLayer";

const LessonsPage = () => {
  return (
    <>
  
        {/* Breadcrumb */}
        <Breadcrumb title="Lessons" />

        {/* AssignRoleLayer */}
        <LessonsLayer />

    </>
  );
};

export default LessonsPage;
